export default {
  en: {
    previous: 'Previous',
    claimSteps: {
      step: 'Step {n}',
      claimProfile: 'Claim supplier profile',
      supplierDetails: 'Add supplier details',
      setUpAccount: 'Set up account',
    },
    claimProfile: {
      errorExpired: 'This invite has expired or been cancelled.',
      title: 'You have been invited by {orgName} to claim your supplier profile',
      li1: 'Speed up security reviews and close deals faster',
      li2: 'Know exactly where you are in the review process',
      li3: 'Never complete a questionnaire from scratch again',
      waiting:
        '{orgName} is waiting to connect with you | {orgName} and one other client is waiting to connect with you | {orgName} and {n} other clients are waiting to connect with you',
      cta: 'Get started',
    },
    orgDetails: {
      title: 'Add your organisation details',
      orgInfo: 'Organisation information',
      businessDetails: 'Business details',
      registeredAddress: 'Registered address',
      continue: 'Continue',
    },
    userDetails: {
      title: 'Set up your personal account',
      passwordRequirements: 'Make sure the password meets the requirements',
      implicitTerms:
        'By creating an account, you agree to our <a href="https://www.riskledger.com/terms" target="_blank">Terms of Service</a> and <a href="https://www.riskledger.com/privacy" target="_blank">Privacy Policy</a>.',
      loginDetails: 'Login details',
      notificationsTitle: 'Email notifications',
      notificationsBody:
        "We send notifications to keep you up to date with important events related to your organisation's security and assurance. We recommend receiving these alerts, but you can always turn them off in your settings later.",
      notificationsText: 'Receive notification emails',
      continue: 'Create account',
      miscFail: 'An unknown error occurred. Contact support for help.',
    },
    confirmSignup: {
      body1:
        "To verify the email address that you've provided, we've emailed you a confirmation code. Please enter this below.",
      body2:
        "This can sometimes go through to your junk folder, but if you're having issues receiving this, reach out to {email} or {intercom} to open a chat.",
      body3: 'The verification code has been sent to {0}.',
    },
    setupMFA: {
      title: 'Set up two factor authentication',
      subtitle: 'Two factor authentication (2FA) is mandatory for all users',
      appTitle: 'Authenticator app',
      appBody1:
        "We recommend using an authenticator app for 2FA as they are more secure and don't rely on mobile services.",
      appBody2:
        'Scan the QR code using your authenticator app or use the secret key to create an authentication code',
      enterCode: 'Enter authentication code',
      smsTitle: 'SMS authentication',
      smsBody: "Don't want to use an authenticator app?",
      smsCTA: 'Use SMS instead',
      scanCode: 'Scan the QR code with your authenticator app',
      copyKey: 'Or copy the secret key',
    },
    orgSurvey: {
      title: "Let's learn about your organisation",
      subtitle: "We'll use this to tailor your experience",
      whoHandlesAssessments: 'Who typically handles security assessments at your organisation?',
      whoHandlesAssessmentsAnswer1: 'I handle them directly',
      whoHandlesAssessmentsAnswer2: 'Dedicated security/compliance team',
      whoHandlesAssessmentsAnswer3: 'Various team members',
      whoHandlesAssessmentsAnswer4: 'External consultant',
      howOften: 'How often does your organisation complete security assessments for clients?',
      howOftenAnswer1: 'This is our first time',
      howOftenAnswer2: 'Occasionally (1-2 times per year)',
      howOftenAnswer3: 'Regularly (3-10 times per year)',
      howOftenAnswer4: 'Frequently (10+ times per year)',
      howOftenAnswer5: "I don't know",
      bestDescription: 'What best describes your security program?',
      bestDescriptionAnswer1: 'Just getting started',
      bestDescriptionAnswer2: 'Basic controls in place',
      bestDescriptionAnswer3: 'Mature program with regular audits',
      bestDescriptionAnswer4: 'Advanced/certified (ISO 27001, SOC 2, etc.)',
      tools: 'Do you currently use any of these tools? Choose all that are relevant',
      toolsAnswer1: 'Security questionnaire tools',
      toolsAnswer2: 'GRC platforms',
      toolsAnswer3: 'Trust centres (Vanta, SafeBase, etc)',
      toolsAnswer4: 'None of the above',
    },
  },
};
